import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from './api';
import './KarsilamaSayfasi.css';

function DemoTalepFormu() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ ad: '', soyad: '', eposta: '', telefon: '' });
  const [kvkkOnay, setKvkkOnay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sonuc, setSonuc] = useState(null); // { kullanici_adi, sifre }

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!kvkkOnay) {
      setError('Devam etmek için KVKK Aydınlatma Metni\'ni onaylamanız gerekmektedir.');
      return;
    }
    setLoading(true);
    setError('');
    setSonuc(null);
    try {
      const response = await api.post('/demo-talep', formData);
      setSonuc(response.data);
    } catch (err) {
      setError(err.response?.data?.mesaj || 'Demo hesap oluşturulurken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <div className="aurora-background" />
      
      {/* Üst navbar */}
      <nav className="landing-navbar">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="navbar-brand-custom d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <div className="brand-icon">
              <span className="material-symbols-outlined">clinical_notes</span>
            </div>
            <span className="brand-text">Diyet-Takip</span>
          </div>
          <Button variant="primary" size="sm" className="login-btn-nav" onClick={() => navigate('/giris')}>
            Giriş Yap
          </Button>
        </Container>
      </nav>

      <div className="d-flex align-items-center justify-content-center" style={{ position: 'relative', zIndex: 1, minHeight: '100vh', paddingTop: '5rem' }}>
        <Card className="glass-card" style={{ width: '28rem', maxWidth: '95%', border: '1px solid rgba(255,255,255,0.08)' }}>
          <Card.Body className="p-4">
            {!sonuc ? (
              <>
                <div className="text-center mb-4">
                  <div className="d-flex justify-content-center mb-3">
                    <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'linear-gradient(135deg, rgba(109,224,57,0.15), rgba(109,224,57,0.05))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '28px', color: 'var(--accent-primary)' }}>rocket_launch</span>
                    </div>
                  </div>
                  <h3 className="fw-bolder" style={{ color: 'var(--text-main)' }}>Ücretsiz Demo Talep Et</h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>10 günlük demo hesabınızla sistemi hemen keşfedin.</p>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Ad</Form.Label>
                    <Form.Control type="text" name="ad" value={formData.ad} onChange={handleChange} required placeholder="Adınız" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Soyad</Form.Label>
                    <Form.Control type="text" name="soyad" value={formData.soyad} onChange={handleChange} required placeholder="Soyadınız" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>E-posta</Form.Label>
                    <Form.Control type="email" name="eposta" value={formData.eposta} onChange={handleChange} required placeholder="ornek@mail.com" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Telefon <span style={{ opacity: 0.5 }}>(opsiyonel)</span></Form.Label>
                    <Form.Control type="tel" name="telefon" value={formData.telefon} onChange={handleChange} placeholder="05XX XXX XX XX" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      id="kvkk-onay"
                      checked={kvkkOnay}
                      onChange={(e) => setKvkkOnay(e.target.checked)}
                      label={
                        <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>
                          <a href="/kvkk" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-primary)' }}>KVKK Aydınlatma Metni</a>'ni okudum;
                          kişisel verilerimin bu kapsamda işlenmesini kabul ediyorum.
                        </span>
                      }
                    />
                  </Form.Group>

                  {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

                  <div className="d-grid">
                    <Button type="submit" className="fw-bold py-2" disabled={loading} style={{ background: 'linear-gradient(135deg, #6de039, #266d00)', border: 'none' }}>
                      {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Demo Hesap Oluştur'}
                    </Button>
                  </div>
                </Form>

                <div className="text-center mt-3">
                  <small style={{ color: 'var(--text-muted)' }}>Zaten hesabınız var mı? <span style={{ color: 'var(--accent-primary)', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => navigate('/giris')}>Giriş Yap</span></small>
                </div>
              </>
            ) : (
              <div className="text-center">
                <div className="mb-4">
                  <div className="d-flex justify-content-center mb-3">
                    <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'linear-gradient(135deg, rgba(109,224,57,0.2), rgba(109,224,57,0.05))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '32px', color: '#6de039' }}>check_circle</span>
                    </div>
                  </div>
                  <h3 className="fw-bolder" style={{ color: 'var(--text-main)' }}>Demo Hesabınız Hazır!</h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Aşağıdaki bilgilerle giriş yapabilirsiniz. Bu bilgileri bir yere not edin.</p>
                </div>

                <div className="p-3 rounded-3 mb-3" style={{ backgroundColor: 'var(--bg-tertiary, rgba(255,255,255,0.05))', border: '1px solid var(--border-color)' }}>
                  <div className="mb-2">
                    <small style={{ color: 'var(--text-muted)', textTransform: 'uppercase', fontSize: '0.7rem', letterSpacing: '1px' }}>Kullanıcı Adı</small>
                    <div className="fw-bold" style={{ color: 'var(--accent-primary)', fontSize: '1.1rem' }}>{sonuc.kullanici_adi}</div>
                  </div>
                  <div>
                    <small style={{ color: 'var(--text-muted)', textTransform: 'uppercase', fontSize: '0.7rem', letterSpacing: '1px' }}>Geçici Şifre</small>
                    <div className="fw-bold" style={{ color: 'var(--accent-primary)', fontSize: '1.1rem', fontFamily: 'monospace' }}>{sonuc.sifre}</div>
                  </div>
                </div>

                <Alert variant="warning" className="text-start" style={{ fontSize: '0.8rem' }}>
                  <strong>Not:</strong> İlk girişte şifrenizi değiştirmeniz istenecektir. Demo hesabınız 10 gün geçerlidir.
                </Alert>

                <div className="d-grid mt-3">
                  <Button className="fw-bold py-2" onClick={() => navigate('/giris')} style={{ background: 'linear-gradient(135deg, #6de039, #266d00)', border: 'none' }}>
                    Giriş Yap <span>&rarr;</span>
                  </Button>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default DemoTalepFormu;
